export function GiftIcon(props) {
  const { ...imgAttrs } = props;

  return (
    <img 
      {...imgAttrs}
      className={`profile-icon profile-icon__gift ${imgAttrs.className ? imgAttrs.className : ""}`} 
      src={"https://wvusstatic.com/illustrations/gift.svg"} 
    />
  )
}

export default GiftIcon;